import { SITE_ORIGIN } from './constants';

type JsonLd = Record<string, unknown>;

export function organizationJsonLd(): JsonLd {
  return {
    '@type': 'Organization',
    '@id': `${SITE_ORIGIN}/#organization`,
    name: 'Santtai',
    url: SITE_ORIGIN,
    logo: `${SITE_ORIGIN}/logo.ico`,
    sameAs: [],
  };
}

export function websiteJsonLd(): JsonLd {
  return {
    '@type': 'WebSite',
    '@id': `${SITE_ORIGIN}/#website`,
    url: SITE_ORIGIN,
    name: 'Santtai',
    publisher: { '@id': `${SITE_ORIGIN}/#organization` },
  };
}

export function breadcrumbJsonLd(
  items: { name: string; url: string }[],
): JsonLd {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function touristDestinationJsonLd(params: {
  name: string;
  url: string;
  description: string;
}): JsonLd {
  return {
    '@type': 'TouristDestination',
    name: params.name,
    url: params.url,
    description: params.description,
  };
}

export function touristTripJsonLd(params: {
  name: string;
  url: string;
  description: string;
}): JsonLd {
  return {
    '@type': 'TouristTrip',
    name: params.name,
    url: params.url,
    description: params.description,
    provider: { '@id': `${SITE_ORIGIN}/#organization` },
  };
}

export function itemListJsonLd(params: {
  name: string;
  url: string;
  items: { name: string; url: string }[];
}): JsonLd {
  return {
    '@type': 'ItemList',
    name: params.name,
    url: params.url,
    numberOfItems: params.items.length,
    itemListElement: params.items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      url: item.url,
    })),
  };
}

export function productJsonLd(params: {
  name: string;
  url: string;
  description: string;
  image?: string;
}): JsonLd {
  return {
    '@type': 'Product',
    name: params.name,
    url: params.url,
    description: params.description,
    brand: { '@type': 'Brand', name: 'Santtai' },
    ...(params.image ? { image: params.image } : {}),
  };
}

export function faqPageJsonLd(
  faqs: { question: string; answer: string }[],
): JsonLd {
  return {
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function buildJsonLdGraph(schemas: JsonLd[]): string {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [organizationJsonLd(), websiteJsonLd(), ...schemas],
  });
}
